export default {
    navigationBarTitleText: '免费设计',
};
